"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributedTypography = void 0;
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
function processText(text) {
    if (text.length === 0)
        return [];
    const elements = [];
    let match;
    const regex = /\{B\}(.*?)\{\/B\}|\^\{(.*?)\}|_\{(.*?)\}/g;
    let lastIndex = 0;
    while ((match = regex.exec(text)) !== null) {
        const boldText = match[1];
        const superscriptText = match[2];
        const subscriptText = match[3];
        if (match.index > lastIndex) {
            const normalText = text.substring(lastIndex, match.index);
            if (normalText.length > 0) {
                elements.push(normalText);
            }
        }
        if (boldText) {
            elements.push(react_1.default.createElement("strong", { key: `bold-${match.index}`, style: { color: '#4CAF50' } }, boldText));
        }
        else if (superscriptText) {
            elements.push(react_1.default.createElement("sup", { key: `sup-${match.index}` }, processText(superscriptText)));
        }
        else if (subscriptText) {
            elements.push(react_1.default.createElement("sub", { key: `sub-${match.index}` }, processText(subscriptText)));
        }
        lastIndex = regex.lastIndex;
    }
    if (lastIndex < text.length) {
        const remainingText = text.substring(lastIndex);
        if (remainingText)
            elements.push(remainingText);
    }
    return elements;
}
function AttributedTypography(props) {
    return react_1.default.createElement(Typography_1.default, { ...props }, processText(props.children));
}
exports.AttributedTypography = AttributedTypography;
